export default __webpack_public_path__ + "static/media/coiffeur.4b4922ea.jpg";